import React from 'react';
import styled from 'styled-components';

import { getSourceType } from 'shared/utils/source';

import { SourceTypeCellProps } from './types';

const StyledContainer = styled.div``;

const StyledSourceType = styled.span``;

const SourceTypeCell = ({
  value: sourceType,
}: SourceTypeCellProps) => (
  <StyledContainer>
    <StyledSourceType>{getSourceType(sourceType)}</StyledSourceType>
  </StyledContainer>
);

export default SourceTypeCell;
